module.exports = __webpack_public_path__ + "img/Poesía.55c9c380.svg";